<template>
  <div class="crew-assignment-alert-tooltip">
    <div class="alert-title">以下のアラートが発生しています。</div>
    <div class="alert-details" v-for="(alert, index) in alerts" :key="index">
      <!-- アイコン + メッセージ要約を横並び -->
      <div class="alert-summary-row flex items-start">
        <span
          class="material-icons crew-assignment-icon"
          :class="{
            warning: isWarning(alert),
            caution: isCaution(alert),
          }"
        >
          error
        </span>
        <span class="alert-summary">
          {{ alert.message_summary }}
        </span>
      </div>

      <!-- 役職名と日付 -->
      <div
        class="alert-role-row"
        v-for="(detail, i) in alert.message_details"
        :key="i"
      >
        <span class="role-name truncate">{{ detail.msg1 }}</span>
        <span class="role-date">{{ detail.msg2[0] }}</span>
        <!-- 配列だが当分メッセージは１つしかないのindex0を指定-->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "TooltipTextVesselAlert",
  props: {
    alerts: {
      type: Array,
      required: true,
    },
  },
  methods: {
    isWarning(alert) {
      return alert.alert_type === "WARNING";
    },
    isCaution(alert) {
      return alert.alert_type === "CAUTION";
    },
  },
};
</script>
<style lang="scss">
.crew-assignment-alert-tooltip {
  // レイアウト指定
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem 0.625rem 0.75rem;

  // タイポグラフィ共通
  color: #fff;
  font-size: 0.75rem; // 12px
  font-style: normal;
  font-weight: 300; // 全体デフォルト
  line-height: 1.125rem; // 18px

  .alert-title {
    font-size: 0.75rem;
    white-space: pre-line;
  }

  .alert-details {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .alert-summary-row {
    display: flex;
    align-items: flex-start;
    width: 100%;
  }

  .crew-assignment-icon {
    display: flex;
    width: 1rem;
    height: 1rem;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1 / 1;
    font-size: 1rem;

    margin-right: 6px;
    flex-shrink: 0;
    &.warning {
      color: #e02e22;
    }
    &.caution {
      color: #ffd400;
    }
  }

  .alert-summary {
    font-weight: 400;
    line-height: 1.125rem;
  }

  .alert-role-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 0.5rem;
    font-size: 0.75rem;
    font-weight: 300;
    line-height: 1.125rem;
  }

  .role-name {
    width: 4.73444rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .role-date {
    width: 8.5rem;
    white-space: nowrap;
  }
}
</style>
